import { NavLink, Outlet } from "react-router-dom";
import { useCan } from "../../../lib/auth";
import { ChannelStatusPill } from "../../../components/youtube/ChannelStatusPill";

/**
 * YouTube management section. Admin-only (gated by `youtube.manage` on the
 * tab in DashboardLayout, plus server-side on each route). Content people
 * upload, edit, and curate from here. The plumbing — Connection, Sync,
 * Quota, Audit — is tucked into Advanced.
 *
 * Tabs:
 *   /dashboard/youtube           → Videos catalog (default)
 *   /dashboard/youtube/upload    → Upload new video
 *   /dashboard/youtube/series    → Manage series (playlists)
 *   /dashboard/youtube/advanced  → Connection · Sync · Quota · Audit
 */

const TABS: ReadonlyArray<{ to: string; label: string; end?: boolean }> = [
  { to: "/dashboard/youtube", label: "Videos", end: true },
  { to: "/dashboard/youtube/upload", label: "Upload" },
  { to: "/dashboard/youtube/series", label: "Series" },
];

export default function YouTubeLayout() {
  const canConnect = useCan("youtube.connect");

  return (
    <div className="container-edit">
      <header className="yt-section-header">
        <div className="yt-section-headline">
          <p className="page-eyebrow mb-1.5">Channel</p>
          <h1 className="page-title">YouTube</h1>
          <p className="font-grotesk text-[0.78rem] text-[var(--color-ink-soft)] mt-2 max-w-[58ch]">
            Classes, recordings, and series of the @vedaunion channel.
          </p>
        </div>
        <ChannelStatusPill />
      </header>

      <nav
        className="yt-section-nav"
        aria-label="YouTube admin sections"
      >
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              `subtab ${isActive ? "is-active" : ""}`
            }
          >
            {t.label}
          </NavLink>
        ))}
        {canConnect && (
          <NavLink
            to="/dashboard/youtube/advanced"
            className={({ isActive }) =>
              `subtab yt-section-advanced ${isActive ? "is-active" : ""}`
            }
          >
            Advanced
          </NavLink>
        )}
      </nav>

      <Outlet />
    </div>
  );
}
